var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailInSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.5 43.125L60 63.75L37.5 43.125H82.5Z",
    fill: "#35294B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 41.25H37.5C37.0027 41.25 36.5258 41.4475 36.1742 41.7992C35.8225 42.1508 35.625 42.6277 35.625 43.125V75C35.625 75.9946 36.0201 76.9484 36.7233 77.6516C37.4266 78.3549 38.3804 78.75 39.375 78.75H80.625C81.6196 78.75 82.5734 78.3549 83.2766 77.6516C83.9799 76.9484 84.375 75.9946 84.375 75V43.125C84.375 42.6277 84.1775 42.1508 83.8258 41.7992C83.4742 41.4475 82.9973 41.25 82.5 41.25ZM62.8359 58.5938L60 61.1953L42.3281 45H77.6719L62.8359 58.5938ZM53.1328 60L39.375 72.6094V47.3906L53.1328 60ZM55.8984 62.5547L58.7344 65.1328C59.08 65.449 59.5315 65.6244 60 65.6244C60.4685 65.6244 60.92 65.449 61.2656 65.1328L64.1016 62.5547L77.6719 75H42.3281L55.8984 62.5547ZM66.8672 60L80.625 47.3906V72.6094L66.8672 60Z",
    fill: "#35294B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 4.5,
    stroke: "#E4EBF6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInSquare);
export default __webpack_public_path__ + "static/media/email_in_square.4fb44e04f8a6e30ff88b38496b107f85.svg";
export { ForwardRef as ReactComponent };